import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=46088be4&scoped=true&"
import script from "./ResultPage.vue?vue&type=script&lang=js&"
export * from "./ResultPage.vue?vue&type=script&lang=js&"
import style0 from "./ResultPage.vue?vue&type=style&index=0&id=46088be4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46088be4",
  null
  
)

export default component.exports